import styled from "styled-components";

export const CardOptionsContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    width: 100%;
    
`